/**
 * MuiIcon — MUI's <Icon> primitive (not to be confused with SvgIcon).
 *
 * Small override: default `fontSize="small"` everywhere, with the
 * "small" variant explicitly sized to 1rem. Keeps icon-only rows in
 * lists and buttons from ballooning under MUI's larger defaults.
 */
export const iconCustomizations = {
  MuiIcon: {
    defaultProps: {
      fontSize: 'small',
    },
    styleOverrides: {
      root: {
        variants: [
          {
            props: {
              fontSize: 'small',
            },
            style: {
              fontSize: '1rem',
            },
          },
        ],
      },
    },
  },
};
